import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const Context = React.createContext()

export function InfractionsProvider({ infractionsByPath, ...props }) {
  return <Context.Provider {...props} value={infractionsByPath} />
}

InfractionsProvider.propTypes = {
  infractionsByPath: PropTypes.object
}

/**
 * @returns {{ [fieldPathWithoutIndex: string]: {
 *    infractionId: string,
 *    infractionType: string,
 *    notes: string,
 *    fieldName: string,
 *    fieldPathWithoutIndex: string,
 *    fieldPathWithIndex: string
 *    }[]
 * }}
 */
function useInfractionContext() {
  return useContext(Context)
}

export function useInfraction(
  pathsWithIndex,
  { matchArrayIndex = false } = {}
) {
  if (!pathsWithIndex) {
    pathsWithIndex = ''
  }
  if (!Array.isArray(pathsWithIndex)) {
    pathsWithIndex = [pathsWithIndex]
  }

  const infractionsByPath = useInfractionContext()
  if (!infractionsByPath) {
    return []
  }
  const paths = pathsWithIndex.map(path => path.replace(/\[\d+\]\./, '[_].'))

  const matches = _.flatMap(paths, path => infractionsByPath?.[path] ?? [])
  return matches.filter(infraction => {
    if (matchArrayIndex) {
      return pathsWithIndex.includes(infraction.fieldPathWithIndex)
    } else {
      return true
    }
  })
}

export function useInfractions() {
  const infractionsByPath = useInfractionContext()

  return infractionsByPath ?? {}
}
